module.exports = __webpack_public_path__ + "static/media/ineuron-01.d77d1932.png";